import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Link, useDocs } from 'docz';
import React, { useState } from 'react';
import { ArrowRight, X } from 'react-feather';
import { Close, DrawerContainer, Results, SearchContainer, Submit } from './custom-styles';
import { jsx as ___EmotionJSX } from "@emotion/core";

var filter = function filter(regex, doc) {
  return doc.tags && regex.test(doc.tags) || regex.test(doc.name);
};

var Search = function Search(_ref) {
  var open = _ref.open,
      toggleOpen = _ref.toggleOpen,
      className = _ref.className,
      rest = _objectWithoutPropertiesLoose(_ref, ["open", "toggleOpen", "className"]);

  var classes = (open ? 'open' : '') + " " + className;

  var _useState = useState(null),
      results = _useState[0],
      setResults = _useState[1];

  var docs = useDocs();

  var search = function search(ev) {
    ev.preventDefault();
    var form = new FormData(ev.target);
    var q = form.get('query');

    if (!q || !q.length) {
      setResults(null);
      return;
    }

    var regex = new RegExp(q, 'i');
    var filtered = docs.filter(filter.bind(null, regex));
    setResults(filtered);
  };

  return ___EmotionJSX(DrawerContainer, _extends({
    className: classes
  }, rest), ___EmotionJSX("div", null, ___EmotionJSX(Close, {
    onClick: function onClick() {
      return toggleOpen(false);
    }
  }, ___EmotionJSX(X, {
    size: 22
  })), ___EmotionJSX(SearchContainer, null, ___EmotionJSX("form", {
    action: "",
    onSubmit: search
  }, ___EmotionJSX("label", {
    htmlFor: "searchQuery",
    "aria-hidden": "true",
    style: {
      display: 'none'
    }
  }, "Search"), ___EmotionJSX("input", {
    id: "searchQuery",
    name: "query",
    type: "text",
    placeholder: "Type to search...",
    "aria-label": "Query"
  }), ___EmotionJSX(Submit, {
    type: "submit",
    "aria-label": "Submit"
  }, ___EmotionJSX(ArrowRight, {
    size: 22
  })))), results && results.length ? ___EmotionJSX(Results, null, results.map(function (doc, i) {
    return ___EmotionJSX(Link, {
      key: i,
      to: doc.route
    }, ___EmotionJSX("h4", null, doc.name), ___EmotionJSX("span", null, doc.route));
  })) : null));
};

export default Search;

if (typeof Search !== 'undefined' && Search && Search === Object(Search) && Object.isExtensible(Search) && !Search.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Search, '__filemeta', {
    configurable: true,
    value: {
      name: "Search",
      filename: "node_modules/gatsby-theme-docz-oh/src/gatsby-theme-docz/components/Search/index.js"
    }
  });
}